import { useQuery } from "@apollo/client";
import { MenuItem, TextField, TextFieldProps } from "@mui/material";

import { ResearchTypeSelectElement_GetAllDocument } from "./queries.generated";

type ResearchTypeSelectElementProps = TextFieldProps; // TODO: reuse ResearchTypeSelect (out of scope for id-3184)

export default function ResearchTypeSelectElement({ ...restProps }: ResearchTypeSelectElementProps) {
    const { data } = useQuery(ResearchTypeSelectElement_GetAllDocument);
    const options = data?.settingsResearchTypeGetAll.data ?? [];

    return (
        <TextField select {...restProps}>
            {options.map(option => (
                <MenuItem key={option.id} value={option.id}>
                    {option.name}
                </MenuItem>
            ))}
        </TextField>
    );
}
